import styled from 'styled-components';
export const Label = styled.div.withConfig({
  displayName: "FormattedCardPropertystyle__Label"
})(["font-size:12px;"]);
export const PropertyValue = styled.div.withConfig({
  displayName: "FormattedCardPropertystyle__PropertyValue"
})(["padding-bottom:15px;"]);